import icons from '~/utils/icons';

export default {
  props: {
    preview: Object,
  },
  data() {
    return {
      internalMobilePreview: false,
    };
  },
  methods: {
    setMobilePreview(mobile) {
      this.internalMobilePreview = mobile;
    },
  },
  computed: {
    icons() {
      return icons;
    },
    isMobileClass() {
      return this.internalMobilePreview ? 'hidden' : '';
    },
    isDesktopClass() {
      return !this.internalMobilePreview ? 'hidden' : '';
    },
  },
  updated() {
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/custom-preview/CustomPreview.js